import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Report templates stats DTO
 */
@CaslSubject(AppSubjectEnum.REPORT_JOB)
export class ReportJobsStatsDto extends BaseStatsDto {
	queued!: number;
	running!: number;
	completed!: number;
	failed!: number;
	cancelled!: number;
}
